import { Component, OnInit } from '@angular/core';
import { CheckoutService } from '../services/checkout.service';
//import { CheckoutState } from './checkout.reducer';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomDSValidators } from '../shared/validators/custom-validators';
import { CompanyService } from '../services/company.service';
import { Company } from '../company/company.interface';
import { ApiService } from '../services/api.service';
import { ResponseService } from '../services/response.service';
import { NotificationsService } from 'angular2-notifications';
import { LocalStorageService } from '../services/local-storage.service';
import { PayUService } from '../services/payu.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import postscribe from 'postscribe';
import { CartService } from '../services/cart.service';

@Component({
    selector: 'app-checkout-company',
    templateUrl: './service-offer-company.component.html',
    styleUrls: ['../../assets/css/bootstrap.min.css', '../../assets/sass/checkout.scss']
})
export class ServiceOfferCompanyComponent implements OnInit {
    //checkout: CheckoutState;

    companyId = '';
    companyForm: FormGroup;
    companies: Company[];

    regulationFiles: any;
    rodoInfo: any;
    API_URL = `${environment.api_url}`;
    validCodes = {};
    notAvailableCodes = {};
    notConnectingCodes = {};
    notForThisLine = {};
    codes: '';
    objectKeys: any;
    services: any | null;

    public loadingCompanyData: boolean = false;

    constructor(
        private checkoutService: CheckoutService,
        private companyService: CompanyService,
        private apiService: ApiService,
        private responseService: ResponseService,
        private notificationsService: NotificationsService,
        private payUService: PayUService,
        private localStorageService: LocalStorageService,
        private router: Router,
        private translate: TranslateService,
        private domSanitizer: DomSanitizer,
        private cartService: CartService,
    ) {
        this.objectKeys = Object.keys;
        this.codes = '';
        //this.checkout = this.checkoutService.getCheckout();
        this.companyForm = new FormGroup({
            'company.name': new FormControl('', [Validators.required]),
            'company.postal_code': new FormControl('', [Validators.required, CustomDSValidators.polishPostalCode]),
            'company.city': new FormControl('', [Validators.required]),
            'company.street': new FormControl('', [Validators.required]),
            'company.street_hn': new FormControl('', [Validators.required]),
            'company.street_ln': new FormControl(''),
            'company.nip': new FormControl('', [Validators.required, CustomDSValidators.nip]),
            'company.country_id': new FormControl('518', [Validators.required]),
            'codes': new FormControl(''),
            accept_terms: new FormControl(false, [Validators.required, Validators.pattern('true')]),
            accept_rodo: new FormControl(false, [Validators.required, Validators.pattern('true')])
        });

    }

    ngOnInit() {
        if(!this.cartService.checkIsActiveCart()){
            this.router.navigateByUrl('/service/offer');
            this.notificationsService.error('UPS!','Nie masz aktualnie dostępnego koszyka');
            return;
        }
        
        this.companyService.getUserCompanies().subscribe(
            (companies: Company[]) => {
                this.companies = companies;
            }
        );

        this.apiService.get('/regulation/active').subscribe(
            (response) => {
                this.regulationFiles = this.responseService.success(false, response);
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }
    
    changeCompany(value) {
        this.companyId = value;

        if (this.companyId == '') {
            return this.resetCompanyForm();
        }

        this.companyService.getCompanyData(value, true).subscribe(
            (company: Company) => {
                this.fillCompanyForm(company);
            },
            (error) => {
                this.notificationsService.error('Ups', 'Błąd podczas zmiany firmy');
            }
        );
    }

    resetCompanyForm() {
        this.fillCompanyForm({
            name: '',
            postal_code: '',
            city: '',
            street: '',
            street_hn: '',
            street_ln: '',
            nip: '',
            country_id: '518',
            accept_terms: this.companyForm.controls['accept_terms'].value,
            accept_rodo: this.companyForm.controls['accept_rodo'].value,
            codes: ''
        } as any);
    }

    fillCompanyForm(company: Company) {
        this.companyForm.setValue({
            'company.name': company.name,
            'company.postal_code': company.postal_code,
            'company.city': company.city,
            'company.street': company.street,
            'company.street_hn': company.street_hn,
            'company.street_ln': company.street_ln,
            'company.nip': company.nip,
            'company.country_id': company.country_id,
            accept_terms: this.companyForm.controls['accept_terms'].value,
            accept_rodo: this.companyForm.controls['accept_rodo'].value,
            'codes': ''
        });
    }

    openFilesModal(modal: any): void {
        modal.open();
    }

    orderAndPayServices() {
        if (this.companyForm.invalid) {
            return this.triggerValidation(this.companyForm);
        }
        const formData = this.companyForm.value;
        const orderData = {
            // order: this.getOptions(this.checkout),
            // agreement_duration: this.getAgreement(this.checkout),
            acceptances: {
                terms: formData.accept_terms,
                rodo: formData.accept_rodo,
            },
            cart: this.cartService.cart,
            company: this.companyId ? this.companyId : {
                name: formData['company.name'],
                nip: formData['company.nip'],
                country_id: formData['company.country_id'],
                street: formData['company.street'],
                street_hn: formData['company.street_hn'],
                street_ln: formData['company.street_ln'],
                postal_code: formData['company.postal_code'],
                city: formData['company.city'],
            },
            codes: this.objectKeys(this.validCodes).join(',')
        };

        this.apiService.post(`/shopping-cart/${this.cartService.cart}/buy`, orderData).subscribe(
            response => {
                const order = this.responseService.success(false, response);
                // if (order.type === 'application') {
                //   this.localStorageService.set('orderAccepted', true);
                //   this.router.navigateByUrl('/checkout/order-accepted');
                //   return;
                // }
                // this.payUService.payUPaymentURL = order.redirect;
                // this.payUService.accessToken = order.access_token;
                // this.payUService.proformaNumber = order.number;

                // this.localStorageService.set('payUURL', order.redirect);
                // this.localStorageService.set('accessToken', order.access_token);
                // this.localStorageService.set('proformaNumber', order.number);

                this.localStorageService.set('paymentInfo', order.paymentInfo);
                this.cartService.clearCart();
                this.router.navigateByUrl('/service/offer/payment');
            },
            error => {
                if (error.status && error.data && error.data.errors) {
                    this.responseService.error(error, this.companyForm);
                    return;
                }
                if (error.data && error.data.status == 'error' && error.data.message) {
                    this.notificationsService.error('Wystąpił problem', error.data.message);
                    return;
                }
                this.notificationsService.error('Ups', this.translate.instant('ORDER.FAILURE'));
            }
        );
    }

    triggerValidation(form: FormGroup) {
        for (let control in form.controls) {
            if (form.controls.hasOwnProperty(control)) {
                form.controls[control].markAsTouched();
                form.controls[control].updateValueAndValidity();
            }
        };
    }

    // getOptions(checkout: CheckoutState) {
    //   const options = [];
    //   checkout.line.groups.forEach(group => {
    //     group.subgroups.forEach(subgroup => {
    //       subgroup.options.forEach(option => {
    //         if (option.checked) {
    //           options.push({ id: option.id, count: option.selectedValue });
    //         }
    //       });
    //     });
    //   });
    //   return options;
    // }

    // getAgreement(checkout: CheckoutState) {
    //   const agreement = checkout.line.agreements.filter(a => {
    //     return a.checked;
    //   });
    //   return agreement[0].value;
    // }

    openTermsModal(modal: any): void {
        modal.open();
        //console.log(modal);
        //this.registerForm.controls['accept_terms'].setValue(!this.registerForm.controls['accept_terms'].value);
    }

    public appendRodo() {
        this.rodoInfo = this.domSanitizer.bypassSecurityTrustHtml('<object style="width:100%;height:100%" type="application/pdf" ' +
            'data="' + this.API_URL + '/rodo/information_obligation?mode=view">' +
            '<p>Obowiązek informacyjny nie możę zostać otwarty, proszę spróbować ponownie za chwilę</p>' +
            '<a href="' + this.API_URL + '/rodo/information_obligation" target="_rodo" title="Obowiązek informacyjny PDF">Pobierz plik PDF</a> ' +
            '</object>');
    }

    loadCompany(): void {
    }

    removeValidCode(codeName) {
        if (this.validCodes.hasOwnProperty(codeName)) {
            delete this.validCodes[codeName];
        }
    }

    getValidCodeActualType() {
        if (this.objectKeys(this.validCodes).length) {
            const firstCodeName = this.objectKeys(this.validCodes)[0];
            return this.validCodes[firstCodeName].target ? 2 : 1;
        }
        return null;
    }

    haveServerDiscountAlready() {
        for (let codeName in this.validCodes) {
            if (this.validCodes.hasOwnProperty(codeName) && this.validCodes[codeName].target_type == 'server')
                return true;
        }
        return false;
    }

    validateCodes($event) {
        this.notAvailableCodes = {};
        this.notConnectingCodes = {};
        const code = this.companyForm.controls['codes'].value;
        const codesWritedByUser = code.replace(/\s+/g, '').split('\,');
        let discountTypeAvailable = this.getValidCodeActualType();
        this.apiService.get('/discount/check?codes=' + codesWritedByUser.join(',')).subscribe(
            response => {
                this.companyForm.controls['codes'].setValue('');
                const codes = this.responseService.success(false, response, 'codes');
                let haveServerDiscount = this.haveServerDiscountAlready();
                for (let codeIndex in codesWritedByUser) {
                    const codeName = codesWritedByUser[codeIndex];
                    let actualDiscountType = null;
                    if (codes.hasOwnProperty(codeName)) {
                        const codeValidated = codes[codeName];
                        // if(codeValidated.line  && codeValidated.line != this.checkout.id) {
                        //   this.notForThisLine[codeName] = codes[codeName];
                        //   continue;
                        // }
                        actualDiscountType = codeValidated.target ? 2 : 1;
                        if (discountTypeAvailable == null || actualDiscountType == discountTypeAvailable) {
                            discountTypeAvailable = actualDiscountType;
                            if (discountTypeAvailable != 1 || !this.objectKeys(this.validCodes).length) {
                                if (!haveServerDiscount) {
                                    if (!this.validCodes.hasOwnProperty(codeName)) {
                                        if (codes[codeName].target_type == 'server') {
                                            haveServerDiscount = true;
                                        }
                                        this.validCodes[codeName] = codes[codeName];
                                    }
                                    continue;
                                }
                            }
                        }
                        if (!this.notConnectingCodes.hasOwnProperty(codeName)) {
                            this.notConnectingCodes[codeName] = codes[codeName];
                        }
                        continue;
                    }
                    if (!this.notAvailableCodes.hasOwnProperty(codeName)) {
                        this.notAvailableCodes[codeName] = codes[codeName];
                    }
                }
                setTimeout(() => {
                    this.notConnectingCodes = {};
                    this.notAvailableCodes = {};
                    this.notForThisLine = {};
                }, 5000);
            },
            error => { }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/service/service-offer-company.component.ts